import React, { useState } from "react";
import { toast } from "react-hot-toast";

const DonatePage = () => {
  const donationAmountOptions = ["18", "36", "72", "custom"];

  const [amountSelection, setAmountSelection] = useState(
    donationAmountOptions[0]
  );
  const [amount, setAmount] = useState(donationAmountOptions[0]);

  const paypalLink =
    "https://www.paypal.com/donate/?hosted_button_id=RCDQ7WLNEECHY";
  const sumitAPILink =
    "https://api.sumit.co.il/billing/payments/beginredirect/";

  const sumitApiKey = "hWq9h3AHMM4iAtDBZaJHJqpfWP6GYTJH55o6O06NLIawV8qRgw";
  const sumitCompanyID = 42824466;

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    const form = e.target;
    const amount = form.amount.value;
    const name = form.name.value;
    const email = form.email.value;
    const phone = form.phone.value ?? null;
    const address = form.address.value ?? null;
    const city = form.city.value ?? null;
    const zipcode = form.zipcode.value ?? null;

    if (!(amount && name && email)) {
      alert("Please provide all details!");
      return;
    }

    const reqBody = {
      Customer: {
        ExternalIdentifier: null,
        NoVAT: null,
        SearchMode: 0,
        Name: name,
        Phone: phone,
        EmailAddress: email,
        City: city,
        Address: address,
        ZipCode: zipcode || null,
        CompanyNumber: null,
        ID: null,
        Folder: null,
      },
      Items: [
        {
          Item: {
            ID: null,
            // "Name": "Donation",
            Name: "Let's Support The 'Tomchey Temimim'",
            Price: parseInt(amount),
            Currency: null,
            Cost: null,
            ExternalIdentifier: null,
            SKU: null,
            SearchMode: null,
          },
          Quantity: 1,
          UnitPrice: parseInt(amount),
          Total: null,
          Currency: null,
          Description: null,
        },
      ],
      VATIncluded: true,
      DocumentType: null,
      RedirectURL: "https://r24app.web.app/donate/success",
      CancelRedirectURL: null,
      ExternalIdentifier: null,
      MaximumPayments: null,
      SendUpdateByEmailAddress: null,
      ExpirationHours: null,
      Theme: null,
      Language: "English",
      Header: null,
      UpdateOrganizationOnSuccess: true,
      UpdateOrganizationOnFailure: true,
      UpdateCustomerOnSuccess: true,
      DocumentDescription: null,
      DraftDocument: null,
      AutomaticallyRedirectToProviderPaymentPage: null,
      IPNURL: null,
      Credentials: {
        CompanyID: sumitCompanyID,
        APIKey: sumitApiKey,
      },
      ResponseLanguage: null,
    };

    try {
      toast.loading("Please wait...");
      const resp = await fetch(sumitAPILink, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify(reqBody),
      });
      const jsonData = await resp.json();

      toast.dismiss();

      const redirectURL = jsonData.Data.RedirectURL;

      window.open(redirectURL, "_self");
    } catch (error) {
      toast.dismiss();
      toast.error("Something went wrong! try again");
      return;
    }
  };

  return (
    <div
      className="w-full bg-blue-50"
      style={{
        backgroundImage: "url('/assets/donate_page/donate_page_bg.webp')",
      }}
    >
      <div className="w-11/12 mt-8 sm:mt-0 mx-auto shadow-2xl md:w-1/2 rounded-3xl bg-white px-8 py-6 flex flex-col items-center justify-center gap-4">
        {/* campaign details */}
        <div className="flex justify-between mt-2 w-full">
          <div className="font-bold border-l-4 border-blue-500 pl-6">
            <h3 className="text-2xl text-red-400">Let's Support</h3>
            <h3 className="text-2xl">
              The "Tomchey <br />
              Temimim"
            </h3>
          </div>
          <div>
            <img
              src="/assets/donate_page/donate_page_logo.jpg"
              alt="logo"
              className="w-32 h-32 object-contain"
            />
          </div>
        </div>

        <div className="mt-2">
          <p>
            The R24 app was made possible by the ongoing efforts of the "Tomchey
            Temimim" yeshivah in Beit Shemesh (Israel).
          </p>
          <p className="mt-4">
            If you like to support the yeshivah, you can do it here. We continue
            to develop the chinuch for the young people and spread the Torah
            knowledge with the R24 app. We also continue to add new app
            features, to make it convenient and useful.
          </p>
          <h3 className="font-bold mt-4">
            Does this app speak to you?
            <br />
            Join us!
          </h3>
        </div>
        {/* campaign details */}

        {/* paypal button */}
        <a
          href={paypalLink}
          className="flex items-center justify-center rounded-lg py-2 px-8 bg-amber-300 hover:bg-amber-400 text-black gap-2"
        >
          <p className="text-lg">Support with</p>
          <img className="h-6" src="/assets/paypal.svg" alt="paypal" />
        </a>
        {/* paypal button */}

        {/* divider */}
        <div className="flex my-4 items-center w-full">
          <div className="border-b flex-1"></div>
          <p className="text-gray-400 mx-4 text-center">OR CREDIT CARD</p>
          <div className="border-b flex-1"></div>
        </div>
        {/* divider */}

        {/* sumit card payment */}
        <div className="w-full">
          <form onSubmit={handleFormSubmit}>
            <label
              htmlFor="amountSelection"
              className="block text-center md:text-left w-full"
            >
              I'd like to donate:
            </label>
            <div className="flex items-end gap-2">
              <div className="w-full">
                <select
                  value={amountSelection}
                  onChange={(e) => {
                    setAmountSelection(e.target.value);
                    if (e.target.value !== "custom") {
                      setAmount(e.target.value);
                    } else {
                      setAmount("");
                    }
                  }}
                  name="amountSelection"
                  id="amountSelection"
                  className="block w-full px-4 py-3 rounded-2xl border"
                  required
                >
                  {donationAmountOptions.map((amount) => (
                    <option key={amount} value={amount}>
                      ₪{amount}
                    </option>
                  ))}
                </select>
              </div>

              <div className="border rounded-xl flex items-center justify-center px-4 w-full md:w-fit mx-auto">
                <label htmlFor="amount" className="text-xl">
                  ₪
                </label>
                <input
                  disabled={amountSelection !== "custom"}
                  min="0"
                  max="100000"
                  required
                  id="amount"
                  name="amount"
                  type="number"
                  value={amount}
                  onChange={(e) => {
                    setAmount(e.target.value);
                  }}
                  className="disabled:cursor-not-allowed outline-none block w-full md:w-20 py-3 rounded-xl"
                />
              </div>
            </div>

            <div className="mt-4">
              <label htmlFor="name" className="block">
                My Name
              </label>
              <input
                required
                type="text"
                name="name"
                id="name"
                placeholder="You can also add the name of your company or organization"
                className="block w-full px-4 py-3 rounded-2xl border"
              />
            </div>
            <div className="flex flex-col md:flex-row gap-4 w-full mt-4 ">
              <div className="w-full">
                <label htmlFor="email" className="block">
                  Email
                </label>
                <input
                  required
                  type="email"
                  name="email"
                  id="email"
                  placeholder="For sending the donation receipt"
                  className="block w-full px-4 py-3 rounded-2xl border"
                />
              </div>
              <div className="w-full">
                <label htmlFor="phone" className="block">
                  Phone
                </label>
                <input
                  type="tel"
                  name="phone"
                  id="phone"
                  placeholder="Your phone number"
                  className="block w-full px-4 py-3 rounded-2xl border"
                />
              </div>
            </div>
            <div className="mt-4">
              <label htmlFor="address" className="block">
                Address
              </label>
              <input
                type="text"
                name="address"
                id="address"
                placeholder="You can add your address if you want it to be shown in the donation receipt"
                className="block w-full px-4 py-3 rounded-2xl border"
              />
            </div>
            <div className="flex flex-col md:flex-row gap-4 w-full mt-4 ">
              <div className="w-full">
                <label htmlFor="city" className="block">
                  City
                </label>
                <input
                  type="text"
                  name="city"
                  id="city"
                  placeholder="You can add your city as well"
                  className="block w-full px-4 py-3 rounded-2xl border"
                />
              </div>
              <div className="w-full">
                <label htmlFor="zipcode" className="block">
                  Zipcode (optional)
                </label>
                <input
                  type="text"
                  name="zipcode"
                  id="zipcode"
                  placeholder="Write your Zipcode here..."
                  className="block w-full px-4 py-3 rounded-2xl border"
                />
              </div>
            </div>

            <button
              type="submit"
              className="flex items-center justify-center rounded-full p-4 bg-indigo-600 hover:bg-indigo-700 text-white gap-2 text-2xl w-full mt-6"
            >
              Support
            </button>
          </form>
        </div>
        {/* sumit card payment */}
      </div>
    </div>
  );
};

export default DonatePage;
